<template>
	<div class="nav-item-wrap" id="nav-item-wrap">
		<div @click="slideBack()" id="slideBack" :class="{'hidden':hideScrollBar || hideLeftArrow}">
           <img src="../../assets/icon/sort-down.png" alt="arrow-left" style="transform: rotate(180deg);">
		</div>
		<ul id="mainNavWrap" class="hb-nav-left" ref="ul">
			<li>
                <router-link to="/" class="navitem">
                    Fiction
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Thought And Feeling
                </router-link>
			</li>
			<li class="active">
                <router-link to="/" class="navitem">
                    Humor
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Scary
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Romance
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Poetry
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Thriller
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Love
                </router-link>
			</li>		
			<li>
                <router-link to="/" class="navitem">
                    Fiction
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Thought And Feeling
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Humor
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Scary
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Romance
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Poetry
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Thriller
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Love
                </router-link>
			</li>		
			<li>
                <router-link to="/" class="navitem">
                    Fiction
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Thought And Feeling
                </router-link>
			</li>
			<li class="active">
                <router-link to="/" class="navitem">
                    Humor
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Scary
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Romance
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Poetry
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Thriller
                </router-link>
			</li>
			<li>
                <router-link to="/" class="navitem">
                    Love
                </router-link>
			</li>			
			
			
		</ul>
		<div @click="slide()" id="slide" type="button" :class="{'hidden':hideScrollBar}">
           <img src="../../assets/icon/sort-down.png" alt="arrow-left">
		</div>
	</div>
</template>



<script>


export default {
  name: "home-main-nav",

	data(){
		return{
			hideScrollBar:true,
			height:0,
			hideLeftArrow:true,
			itemNo:0,
		}
	},

	methods:{

		slideBack(){
		    var container = document.getElementById('mainNavWrap');
		    this.sideScroll(container,'left',25,100,10);
		},

		slide() {
			var lis = this.$refs.ul.getElementsByTagName("li");
			var container = document.getElementById('mainNavWrap');
		    this.sideScroll(container,'right',25,lis[this.itemNo].clientWidth+35,10);
		    this.itemNo++;
		},


		sideScroll(element,direction,speed,distance,step){
		    var scrollAmount = 0;
		    var slideTimer = setInterval(function(){
		        if(direction == 'left'){
		            element.scrollLeft -= step;
		        } else {
		            element.scrollLeft += step;
		        }
		        scrollAmount += step;
		        if(scrollAmount >= distance){
		            window.clearInterval(slideTimer);
		        }
		    }, speed);

		    // scroll left
		 	if(element.scrollLeft == 0) {
		 		this.hideLeftArrow = true;
		 	} else {
		 		this.hideLeftArrow = false;
		 	}
		},

		hasScroll(){

			if (this.$refs.ul.clientWidth >= this.$refs.ul.scrollWidth) {
		    	this.hideScrollBar = true;
		    } else {
		    	this.hideScrollBar = false;
		    }
		}

	},
	mounted () {
	    this.hasScroll();
	}
	
}

</script>



<style type="text/css">

	.nav-item-wrap {
	    max-width: 78%;
	    position: relative;
	}
	#mainNavWrap {
		width: 100%;
	    -webkit-box-pack: end;
	    -ms-flex-pack: end;
	    justify-content: end;
	    white-space: nowrap;
	    overflow-x: auto;
	}

	.hidden {
		display: none;
	}

	#slide,
	#slideBack{
		position: absolute;
	    top: 35px;
	    width: 22px;
	    height: 22px;
	    line-height: 26px;
	    text-align: center;
	    cursor: pointer;
	}
	#slideBack{
		left: -22px;
	}

	#slide{
		right: -22px;
	}

	.showLeftArrow{
		display: block !important;
	}

	#mainNavWrap::-webkit-scrollbar,
	.nav-item-wrap::-webkit-scrollbar {
	  display: none !important;
	}


	.mainNav .hb-nav-left li .navitem {
	    padding: 36px 0px;
	    display: block;
	}
	.mainNav .hb-nav-left li.active .navitem {
	     color: #00c6c6;;
	     font-weight: 700;
	     border-bottom: 2px solid #00c6c6;
	}

	.mainNav .navIcon {
	    font-size: 17px;
	    margin-left: 5px;
	}

	@media only screen and (max-width: 1199px) {

	    .mainNav .hb-nav-left li .navitem {
	        padding: 17px 0px;
	        display: block;
	    }

	    #slide, #slideBack {
		    top: 15px;
		}

	}

	@media only screen and (max-width: 768px) {
		#mainNavWrap{
		    overflow: hidden;
		    overflow-x: auto;
		    position: absolute;
		    width: 90% !important;
    		margin-left: 5%;
		}

	    #mainNavWrap li .navitem {
		    font-size: 13px !important;
		    color: rgba(33, 65, 99, .6) !important;
		    letter-spacing: 0.7142857px !important;
	    }
		.mainNav .hb-nav-right li .navitem.btn {
		    width: auto !important;
		}

		#mainNavWrap li:last-child {
			display: none;
		}


		#mainNavWrap li.active .navitem {
		    color: #00c6c6 !important;
		    font-weight: 700;
		    position: relative;
		}

		#mainNavWrap li.active .navitem:after {
		    content: "";
		    width: 8px;
		    height: 8px;
		    background: #00c6c6;
		    bottom: -15px;
		    left: 45%;
		    position: absolute;
		    border-radius: 100%;
		}

		#slide,
		#slideBack{
			display: none;
		}
	}

</style>